import { GET, POST, PUT } from "./common/http";
import { BASE_URL } from "./common/const";

 
export const GetTempTypeList = (params: any) =>
  GET(`${BASE_URL}/temperatureType/list?` + params, null);
                          